// extracted by mini-css-extract-plugin
export default {"loaderContainer":"PortalContent__loaderContainer__hPJBG","content":"PortalContent__content__ivaA7"};